import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { HelpCircle } from 'lucide-react';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string | React.ReactNode;
}

export const HelpModal: React.FC<HelpModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto bg-white dark:bg-gray-800">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
              <HelpCircle className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <DialogTitle className="text-xl text-gray-900 dark:text-gray-100">{title}</DialogTitle>
              <DialogDescription className="text-sm mt-1 text-gray-600 dark:text-gray-400">
                Learn more about this feature
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="mt-4">
          {typeof content === 'string' ? (
            <div className="prose prose-sm max-w-none">
              <p className="text-gray-900 dark:text-gray-100 whitespace-pre-wrap leading-relaxed">
                {content}
              </p>
            </div>
          ) : (
            <div className="text-gray-900 dark:text-gray-100 [&_p]:text-gray-900 [&_p]:dark:text-gray-100 [&_p]:leading-relaxed [&_h4]:text-gray-900 [&_h4]:dark:text-gray-100 [&_h4]:font-semibold [&_h4]:text-base [&_h4]:mt-4 [&_h4]:mb-2 [&_code]:text-indigo-700 [&_code]:dark:text-indigo-300 [&_code]:bg-indigo-50 [&_code]:dark:bg-indigo-900/30 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_div]:text-gray-900 [&_div]:dark:text-gray-100 [&_.border-t]:border-gray-300 [&_.border-t]:dark:border-gray-600">
              {content}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

